import { FC, useEffect } from 'react';
import { DAFCheckout } from './DAF';
import { StripeCheckout } from './Stripe';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { getPathWithRef } from 'helpers/utils';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { getSelectedCandidates, getUrlSearchParamsStrWithoutRecipients } from 'helpers/donate';
import { OathRecurringInterval } from 'store/pay/types';
import { TicketWithQuantitySelected } from 'store/eventPage/types';

interface Props {
  candidates: CandidateType[];
  clientId?: number;
  isRecurring: boolean;
  clientName?: string;
  pageId?: number;
  pageName?: string;
  pageOwner: string;
  pageQueryString?: string;
  donationAmount: number;
  recurringInterval: OathRecurringInterval;
  ticketSelections: TicketWithQuantitySelected[];
}

export const CheckoutBase: FC<Props> = ({
  candidates,
  donationAmount,
  clientId,
  isRecurring,
  clientName,
  pageId,
  pageName,
  pageOwner,
  pageQueryString,
  recurringInterval = 'month',
  ticketSelections,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!donationAmount || getSelectedCandidates(candidates).length === 0) {
      navigate(getPathWithRef(`/donate?${getUrlSearchParamsStrWithoutRecipients()}`));
    }
  }, []);

  return (
    <Routes>
      <Route
        path="daf"
        element={
          <DAFCheckout
            candidates={candidates}
            donationAmount={donationAmount}
            clientId={clientId}
            pageId={pageId}
          />
        }
      />
      <Route
        path="standard"
        element={
          <StripeCheckout
            candidates={candidates}
            donationAmount={donationAmount}
            clientId={clientId}
            isRecurring={isRecurring}
            clientName={clientName}
            pageId={pageId}
            pageName={pageName}
            pageOwner={pageOwner}
            pageQueryString={pageQueryString}
            recurringInterval={recurringInterval}
            ticketSelections={ticketSelections}
          />
        }
      />
    </Routes>
  );
};
